module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_03-450-5d9b9ac698cfc4e17de6662a20d7dca2.png";